import React, {useEffect, useState} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {useConfig} from '../../context/ConfigContext';
import axios from "axios";
import IframeResizer from "iframe-resizer-react";

const LoadbeeBosch = ({ brand, barcode }) => {
    const { config } = useConfig();
    const { bosch, loading } = config || {};
    const [params, setParams] = useState({
        is_active: "0",
        api_key: null,
        locale: null
    })
    const [loadbeeParams, setLoadbeeParams] = useState(null)

    const loadProduct = async (barcode) => {
        if (barcode) {
            try {
                const _params = {
                    params: {
                        apiKey: params.api_key,
                    }
                };
                const uri = 'https://availability.loadbee.com/v3/EAN/' + barcode + '/' + params.locale
                const response = await axios.get(uri, _params);
                setLoadbeeParams(response.data)
            } catch (error) {
            }
        }
    }

    useEffect(() => {
        if (config) {
            const {bosch} = config || {bosch: null};
            setParams(bosch)
        }
    }, [config])

    useEffect(() => {
        if (params?.is_active == "1") {
            loadProduct(barcode)
        }
    }, [params])

    useEffect(() => {
        setLoadbeeParams(null)
        if (brand.toUpperCase() === "BOSCH") {
            loadProduct(barcode)
        }
    }, [barcode])


    if (loadbeeParams) {
        return (
            <>
                <IframeResizer
                    id='loadbeeIframeId'
                    src={loadbeeParams.url}
                    checkOrigin={false}
                />
            </>
        )
    }

    if(!(brand.toUpperCase() === "BOSCH")){
        return <></>
    }

    if (!bosch && !loading) {
        return <></>;
    }
    if (params.is_active !== "1") {
        return <></>;
    }

    return null

}

export default (LoadbeeBosch);